var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSadEmoji(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5001 42.4319C2.85968 42.4132 -6.5167 19.7751 6.65106 6.58267C14.4676 -1.56309 28.5327 -1.5644 36.3492 6.58299C49.5168 19.7768 40.1394 42.4143 21.5001 42.4319ZM21.5001 2.23675C10.9158 2.23675 2.30482 10.8477 2.30482 21.432C3.35924 46.8971 39.6447 46.8896 40.6953 21.4318C40.6953 10.8477 32.0843 2.23675 21.5001 2.23675Z",
    fill: "url(#paint0_linear_3889_3462)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5001 2.23675C10.9158 2.23675 2.30482 10.8477 2.30482 21.432C3.35924 46.8971 39.6447 46.8896 40.6953 21.4318C40.6953 10.8477 32.0843 2.23675 21.5001 2.23675Z",
    fill: "url(#paint1_linear_3889_3462)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6064 14.6676C12.419 14.6676 11.4531 15.6335 11.4531 16.8208C11.5714 19.6774 15.6417 19.6766 15.7596 16.8208C15.7596 15.6334 14.7936 14.6676 13.6064 14.6676Z",
    fill: "#2D2D2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.953 14.6676C27.7657 14.6676 26.7998 15.6335 26.7998 16.8208C26.9181 19.6774 30.9884 19.6766 31.1063 16.8208C31.1063 15.6334 30.1403 14.6676 28.953 14.6676Z",
    fill: "#2D2D2D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9083 33.1307C31.5876 33.1307 31.2771 32.9594 31.1138 32.6575C26.9967 24.9247 16.0889 24.9048 11.9414 32.6172C11.7026 33.0544 11.1544 33.2154 10.717 32.9765C10.2797 32.7376 10.1188 32.1894 10.3577 31.7521C15.1761 22.7899 27.9214 22.8169 32.7011 31.799C33.0309 32.3831 32.576 33.1432 31.9083 33.1307Z",
    fill: "#2D2D2D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3889_3462",
    x1: 3.309,
    y1: 31.9465,
    x2: 39.6732,
    y2: 10.9319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB34D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#ECB64D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#EEC04F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F1CC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3D652"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3889_3462",
    x1: 3.309,
    y1: 31.9465,
    x2: 39.6732,
    y2: 10.9319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB34D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#ECB64D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#EEC04F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F1CC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3D652"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadEmoji);
export default __webpack_public_path__ + "static/media/sad-emoji.9448293de69e9968a5434887d6e6c09c.svg";
export { ForwardRef as ReactComponent };